export default __webpack_public_path__ + "static/media/GenericNotify.c7f5af5d.mp3";